// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-animation {
  background-color: #a8a8a84f;
  position: absolute;
  width: 100%;
  top: 0px;
  left: 0px;
  height: 100%;
  align-items: center;
  justify-content: center;
  display: grid;
  z-index: 9999999;
}

.error-icon {
  color: red;
  font-size: 100%;
    width: auto;
    height: 60%;
}

.loader-title {
  font-weight: 900;
  padding: 0;
  margin-top: 5px;
  color: #000;
  font-size: 40%;
}

.loader-container {
  display: flex;
  gap: 0;
  flex-direction: column;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/component/loader-spinner/loader-spinner.component.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,eAAe;IACb,WAAW;IACX,WAAW;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,sBAAsB;EACtB,mBAAmB;AACrB","sourcesContent":[".loading-animation {\r\n  background-color: #a8a8a84f;\r\n  position: absolute;\r\n  width: 100%;\r\n  top: 0px;\r\n  left: 0px;\r\n  height: 100%;\r\n  align-items: center;\r\n  justify-content: center;\r\n  display: grid;\r\n  z-index: 9999999;\r\n}\r\n\r\n.error-icon {\r\n  color: red;\r\n  font-size: 100%;\r\n    width: auto;\r\n    height: 60%;\r\n}\r\n\r\n.loader-title {\r\n  font-weight: 900;\r\n  padding: 0;\r\n  margin-top: 5px;\r\n  color: #000;\r\n  font-size: 40%;\r\n}\r\n\r\n.loader-container {\r\n  display: flex;\r\n  gap: 0;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
